// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__20-cQ","header":"MessagesList_header__3P5Lw","chat":"MessagesList_chat__3u3Ag"};